import { Component, Input } from '@angular/core';
import {
  PasswordRequirement,
  evaluatePasswordRequirements,
  getPasswordScore,
  getPasswordStrengthLabel,
} from './password-requirements';

// Mirrors impatasite/src/app/shared/password-strength/password-strength.component.ts.
// Keep the two in step — the password experience is meant to match across apps.
@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent {
  @Input() password = '';

  readonly maxScore = 6;

  get requirements(): PasswordRequirement[] {
    return evaluatePasswordRequirements(this.password);
  }

  get score(): number {
    return getPasswordScore(this.password);
  }

  get scorePercent(): number {
    return (this.score / this.maxScore) * 100;
  }

  get strengthLabel(): string {
    return getPasswordStrengthLabel(this.score);
  }
}
